import { render, staticRenderFns } from "./UserDataModal.vue?vue&type=template&id=7024a6a0&"
import script from "./UserDataModal.vue?vue&type=script&lang=js&"
export * from "./UserDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports